var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('route-list-data-table',{attrs:{"title":"Completed","defaultSortField":"completed_at","defaultSortOrder":"dsc","headers":_vm.headers,"status":_vm.status,"assocs":_vm.assocs,"routeClickGoTo":"route-info"}})}
var staticRenderFns = []

export { render, staticRenderFns }